import ResizeObserver from 'resize-observer-polyfill';
import smoothScroll from 'smoothscroll-polyfill';

window.ResizeObserver ??= ResizeObserver;

smoothScroll.polyfill();
